import Notification from "notifications/entities/notification/notification";
import MessageNotification from "notifications/entities/message-notification/message-notification";
import { Action } from "notifications/values/action/action";
import { notificationLinks } from "config";
import NotificationTopic from "notifications/values/notification-topic/notification-topic";

export type NotificationType = Notification & MessageNotification;

export function NotificationLink(notification: NotificationType): string {
  if (!notification) return "";
  const id = notification.topic?.id;
  const category = notification.topic?.category ?? "";
  let url = notificationLinks[category as keyof typeof notificationLinks];

  if (!id) return url;

  if (notification.messageInfo) {
    return `/communications/forums/view/${notification.messageInfo.forumInfo.id}`;
  }

  const action: Action | undefined = notification.actionRequired;
  const topic: NotificationTopic | null | undefined = notification.topic;
  let actionType: "view" | "edit" | "revise" | "review" = "view";
  let pageTab = "active";
  let tab = "";

  switch (action) {
    case Action.DraftProposalReview:
      pageTab = "drafts";
      actionType = "review";
      break;
    case Action.DraftProposalReviewApproved:
      pageTab = "drafts";
      actionType = "edit";
      break;
    case Action.ProposalReview:
      actionType = "review";
      break;
    case Action.ProposalRevisionReview:
      actionType = "revise";
      if (topic?.category === "Work.Agreement") {
        pageTab = "drafts";
      }
      break;
    case Action.Review:
    case Action.ProposalReviewApproved:
    case Action.HireOrCancel:
      actionType = "revise";
      break;
  }

  url = url.replace("{pageTab}", pageTab);
  url = url.replace("{action}", actionType);
  url = url.replace("{topicId}", id.value);
  return url.replace("{tab}", tab);
}
